export default __webpack_public_path__ + "static/media/Lombardenveld.abfe5494.png";